import React, { useContext, useEffect, useState } from 'react';
import { ChevronRight } from 'react-feather';

import { useScreenTransition } from '../Hooks/useScreenTransition';
import { TransitionContext } from '../Context/TransitionContext';
import TopBar from '../Components/TopBar';
import SignInForm from './SignIn/SignInForm';
import CreateAccount from './CreateAccount/CreateAccount';


import { ReactComponent as Frame1 } from "../assets/home/Frame1.svg";
import { ReactComponent as Frame2 } from "../assets/home/Frame2.svg";
import { ReactComponent as Group2 } from "../assets/home/Group2.svg";
import { ReactComponent as Listbox } from "../assets/home/Listbox.svg";

import mexicoFlag from "../assets/flags/mexicoFlag.png";
import germanyFlag from "../assets/flags/germanyFlag.png";
import USAFlag from "../assets/flags/USAFlag.png";

import './Languages.css';
import Navbar from './HomePage/header';

import { languages } from '../Data/languages';
import Footer from './HomePage/footer';
import SupportSection from './HomePage/SupportSection';

const Languages = ({ windowSize }) => {

  const { setColor, webP } = useContext(TransitionContext);

  useEffect(() => {
    setColor(false);
  }, [setColor]);

  const [isModalOpen, setIsModalOpen]=useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen]=useState(false);


  const handleLoginOpen=(newState)=>{
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen=(newState)=>{
    setIsCreateAccountOpen(newState);
  }

  const { transitionTo } = useScreenTransition();
  


  return (
    <div className='bg-[#EFF3F5] w-full flex flex-col items-center cursor-default'>
      <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen}/>
      <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen}/>


       {/* banner */}
       <div className='w-full md:p-4 p-2'>

        <div className='w-full bg-[#12ABBF] rounded-4xl max-md:rounded-xl max-md:pb-4'>
            {/* navbar */}
          <div className=' pt-[30px] pb-[27px] mx-4'>
              <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen}/>
          </div>
          <div className='bannerContainer px-2'>
              <h1 className='bannerText text-center'>Language Translation Services<br/> <span>60+ Languages Covered</span></h1>
          </div>
          <div className='flex flex-col gap-4 w-full items-center px-2'>
            <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>Our team has a strong grasp of grammar in English as well as their native language. We guarantee your project's success by pairing you with a industry-specific professional translator.</p>
            <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>If the language pair you need to be translated doesn't include English, <span className="hoveringTextLink" onClick={() => transitionTo('/contact')}>contact us</span> for options before ordering.</p>
          </div>
          <div className=''>
              <p className='flagText'> 🇲🇽 🇨🇳 🇻🇳 🇰🇷 🇧🇷 🇷🇺 🇺🇦 🇫🇷 🇮🇳 🇦🇫 🇵🇭 🇮🇷 🇹🇭 🇹🇷 🇯🇵 🇩🇪 🇮🇹 🇵🇹 🇬🇷 🇵🇱 🇦🇷</p>
          </div>


          <div className=" container  justify-center gap-4 lg:mt-32 mt-10 relative mx-auto flex  w-full max-md:hidden">
              <Frame1 className="max-h-full max-w-full  bg-cover bg-no-repeat lg:block hidden" />

              <div className="relative sm:block hidden">
              <Frame2 className="max-h-full max-w-full  bg-cover bg-no-repeat" />
              <div className="absolute bg-white lg:hidden flex justify-center items-center p-4 rounded-full z-20 -top-6 -left-6 shadow-md">
                  <img src={USAFlag} alt="Flag" className="h-10 w-10" />
              </div>
              <div className="absolute bg-white lg:hidden flex justify-center items-center p-3 rounded-full z-20 -bottom-6 -right-6 shadow-md">
                  <img src={mexicoFlag} alt="Flag" className="h-10 w-10" />
              </div>
              </div>

              <div className="relative sm:hidden block">
              <Listbox className="max-h-full max-w-full  bg-cover bg-no-repeat" />
              <div className="absolute bg-white lg:hidden flex justify-center items-center p-3 rounded-full z-20 -top-6 -left-8 shadow-md">
                  <img src={USAFlag} alt="Flag" className="h-10 w-10" />
              </div>
              </div>

              <div className="absolute bg-white lg:flex hidden justify-center items-center p-4 rounded-full z-20 -top-6 left-[53%] shadow-md">
              <img src={USAFlag} alt="Flag" className="h-10 w-10" />
              </div>

              <div className="absolute -top-1/2 lg:block hidden">
              <div className="w-full relative">
                  <div className="absolute bg-white flex justify-center items-center p-3 rounded-full z-50 top-12 left-6 shadow-md">
                  <img src={germanyFlag} alt="Flag" className="h-8 w-8" />
                  </div>
                  <div className="absolute bg-white flex justify-center items-center p-3 rounded-full z-50 bottom-12 right-6 shadow-md">
                  <img src={mexicoFlag} alt="Flag" className="h-8 w-8" />
                  </div>
                  <Group2 className="z-40 max-h-full max-w-full bg-cover bg-no-repeat" />
              </div>
              </div>
          </div>
        </div>

        <div className="bg-white rounded-4xl overflow-hidden shadow-sm py-12 my-4 max-md:rounded-xl">
          <h2 className='font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase text-center mb-10 px-8'>Languages We Cover</h2>
            <div className="grid grid-cols-4 gap-5 md:max-h-full max-md:grid-cols-2 md:overflow-hidden overflow-y-scroll px-8 max-w-[1440px] justify-center mx-auto">
              {languages.map((item, index) => (
                <div
                  key={index}
                  className="flex gap-3 items-center justify-between"
                >
                  <div className="flex gap-2 items-center justify-center">
                    <span className="text-xl">
                      {/* <img
                        src={item.flag}
                        alt={item.flag}
                        className="h-6 w-6"
                      /> */}
                    <ChevronRight color="#18b7bb" size={windowSize.width > 1024 ? 23 : windowSize.width > 767 ? 20 : 18} />

                    </span>
                    <span className="text-xl">{item.label}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
      <SupportSection windowSize={windowSize} />

       </div>

      <div className=' w-full pb-10 bg-[#12ABBF]'>
            <Footer windowSize={windowSize} light={true}  />
        </div>  

    </div>
  );
}

export default Languages;